import { render, staticRenderFns } from "./ErrorDialog.vue?vue&type=template&id=0ed12623&"
import script from "./ErrorDialog.vue?vue&type=script&lang=js&"
export * from "./ErrorDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports